import { intersection } from 'lodash'
import { getModelValue, setModelValue } from './model'
import { ENV } from '../config'
import { http } from './http'
import bus from './bus'
import Router from '@/layout/router'

import { setInnerKey } from './decrypt-max-plugin'

const log = ENV !== 'prd' ? console.log : function noop () {}

class DecryptPlugin {
  constructor () {
    this.cache = {}
    bus.$on('GLOBAL_MENU_CLOSE', this.remove.bind(this))
  }

  /**
   * 拦截解密接口，存储到本地
   * 数据结构：{ menuId: { 路由name: { dataId: [解密字段] } } }
   * @param menuId
   * @param params
   */
  save (menuId, params) {
    if (menuId && params && Router.currentRoute) {
      try {
        if (typeof params === 'string') {
          params = JSON.parse(params)
        }
        let id = params.dataId
        let key = params.fieldName
        if (key && id && id !== '0') {
          let name = Router.currentRoute.name
          let obj = this.cache[menuId] || {}
          if (obj[name]) {
            let keys = obj[name][id]
            if (!keys) {
              obj[name][id] = [key]
            } else if (!keys.includes(key)) {
              keys.push(key)
            }
          } else {
            obj[name] = { [id]: [key] }
          }
          this.cache[menuId] = obj
        }
      } catch (e) {
        console.error(e)
      }
    }
  }

  /**
   * 判断单条数据的单个字段是否本地有缓存
   * @param menuId
   * @param dataId
   * @param fieldName
   * @returns {*}
   */
  isCached (menuId, dataId, fieldName) {
    if (menuId && dataId && dataId !== '0' && fieldName && Router.currentRoute) {
      let name = Router.currentRoute.name
      let obj = this.cache[menuId]
      obj = obj && obj[name] && obj[name][dataId]
      obj = obj && obj.includes(fieldName)
      obj && log('[decrypt-plugin]', name, dataId, fieldName)
      return obj
    }
    return false
  }

  /**
   * 批量解密
   * @param menuId
   * @param bizId
   * @param rows
   * @param cb
   */
  async batchDecrypt (menuId, bizId, rows, cb) {
    let result = this.getCachedData(menuId, bizId, rows)
    if (result) {
      let { name, map, data } = result
      // 批量解密
      let list = await http('syslog.sensitiveFieldViewLog.decrypt', data, false)
      if (list && list.length) {
        list.forEach((v, i) => {
          let { fieldContent, fieldName } = v
          if (fieldContent !== null && fieldName && fieldName.dataId && fieldName.fieldName) {
              setInnerKey(fieldName.fieldName, map[fieldName.dataId], i + 1, bizId)
              setModelValue(fieldContent, map[fieldName.dataId], fieldName.fieldName)
          }
        })
        rows.splice(0, 1, rows[0])
        cb && cb(list)
        log('[decrypt-plugin]', name, bizId, list)
      }
    }
  }

  /**
   * 对比本地缓存和当前rows，构造批量解密接口的入参
   * @param menuId
   * @param bizId
   * @param rows
   * @returns {*}
   */
  getCachedData (menuId, bizId, rows) {
    if (menuId && bizId && rows && rows.length && Router.currentRoute) {
      let name = Router.currentRoute.name
      // 检测bizId唯一性
      if (this.isRepeated(name, bizId, rows)) {
        return false
      }
      let obj = this.cache[menuId] && this.cache[menuId][name]
      if (obj) {
        let mapAll = rows.reduce((s, v) => {
          s[getModelValue(v, bizId)] = v
          return s
        }, {})
        // 交集就是需要批量自动解密的数据
        let ids = intersection(Object.keys(obj), Object.keys(mapAll))
        if (ids && ids.length > 0) {
          const data = []
          const map = {}
          ids.forEach(v => {
            let row = mapAll[v]
            map[v] = row
            let keys = obj[v]
            keys && keys.forEach(k => {
              let mask = k && getModelValue(row, k + 'Mask')
              if (mask) {
                data.push({
                  fieldName: { dataId: v, fieldName: k },
                  fieldContent: mask
                })
              }
            })
          })
          return data.length ? { data, map, name } : false
        }
      }
      return false
    }
    return false
  }

  /**
   * 菜单关闭时清除对应的缓存
   * @param menuIds
   */
  remove (menuIds) {
    if (menuIds && menuIds.length) {
      menuIds.forEach(v => {
        delete this.cache[v]
      })
    }
  }
  /**
   * 手动清除缓存数据中的某一项
   * @param menuIds
   */
  removeCacheItem (menuId, id, key) {
    let name = Router.currentRoute.name

    if (menuId && id && id !== '0') {
      let obj = this.cache[menuId] && this.cache[menuId][name]
      let arr = obj && obj[id] ? obj[id] : []
      if (Array.isArray(arr)) {
        const isExit = arr.findIndex(x => x === key)
        isExit > -1 && arr.splice(isExit, 1)
      }
    }
  }

  isRepeated (name, bizId, rows) {
    let ids = rows.map(v => getModelValue(v, bizId))
    let size = new Set(ids).size
    if (size !== ids.length) {
      log('[decrypt-plugin] bizId不唯一', name, bizId, size, ids.length)
      return true
    }
    return false
  }
}

export default new DecryptPlugin()



// WEBPACK FOOTER //
// ./src/public/utils/decrypt-plugin.js